import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { handleCallNewsApp, h5PageCount } from 'ThreeTerminal_utils';

class HotNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    handleClick = content => {
        const { url, base62Id, id, type } = content;
        const nodata = '';
        const doc_type = type === 'article' ? 'doc' : type;
        const aid = `ucms_${base62Id}`;
        const to_url = url;
        const downloads = {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1429035767411',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=2905',
        };

        const clickCountConfig = {
            behavior: 'action',
            type: 'downopen',
            other: {
                ref: `ucms_${base62Id}`,
                to: true,
                kind: 'article',
                url: encodeURIComponent(location.href),
                plat: 'napp',
                downurl: encodeURIComponent(
                    'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1348580715362',
                ),
            },
        };

        this.feedClickCountFn(clickCountConfig);

        handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, 'in_sf01', {}, downloads);
    };

    feedClickCountFn = config => {
        if (config) {
            h5PageCount([config]);
        }
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.hot_box}>
                {content.map((item, index) => (
                    <div className={styles.hot_spots} key={index}>
                        <a onClick={this.handleClick.bind(this, item)}>{item.title}</a>
                    </div>
                ))}
            </div>
        );
    }
}

export default errorBoundary(HotNews);
